import {GridConfig} from 'types/api';

export const fetchGridConfig = async (name: string): Promise<GridConfig> => {
    const configs = JSON.parse(localStorage.getItem('gridsConfig') || '[]');
    const result = configs.find((item: GridConfig) => item.name === name);
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(result as GridConfig);
        }, 200);
    });
};

export const saveGridConfig = async (config: GridConfig): Promise<GridConfig> => {
    const configs = JSON.parse(localStorage.getItem('gridsConfig') || '[]');
    const index = configs.findIndex((item: GridConfig) => item.name === config.name);
    if (index === -1) {
        configs.push(config);
    } else {
        configs[index] = config;
    }
    localStorage.setItem('gridsConfig', JSON.stringify(configs));
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(config);
        }, 200);
    });
};
